<template>
    <module-card>
        <p>Great job! Here's a summary of the 12 steps to effective condom use:</p>
        <ol>
            <li v-for="step in steps" :key="step.order">{{ step.step }}</li>
        </ol>
    </module-card>
</template>

<script>
    export default {
        data() {
            return {
                steps: [
                    {
                        order: 1,
                        step: 'Check the expiration date on the wrapper'
                    },
                    {
                        order: 2,
                        step: 'Open the package without tearing the condom'
                    },
                    {
                        order: 3,
                        step: 'Squeeze a few drops of water-based lube into the tip of the condom'
                    },
                    {
                        order: 4,
                        step: 'Hold the condom by the last ½ inch at the tip, squeeze out any air'
                    },
                    {
                        order: 5,
                        step: 'Start to put the condom on when the dick is hard and before the dick touches the partner’s genitalia, mouth or ass'
                    },
                    {
                        order: 6,
                        step: 'Put the condom on the tip of the dick'
                    },
                    {
                        order: 7,
                        step: 'While still pinching the tip, unroll the condom down the shaft of the dick'
                    },
                    {
                        order: 8,
                        step: 'Check during sex to make sure the condom isn’t slipping off'
                    },
                    {
                        order: 9,
                        step: 'After cumming, pull out while holding the condom by its rim (at the base of the dick, near the balls)'
                    },
                    {
                        order: 10,
                        step: 'Remove the condom while holding it by the base or rim (and away from the partner’s body)'
                    },
                    {
                        order: 11,
                        step: 'Throw the condom away (not in a toilet!)'
                    },
                    {
                        order: 12,
                        step: 'Never re-use a condom. Use a new one every time you have sex, and repeat these steps.'
                    }
                ]
            };
        }
    };
</script>
